import type { FC } from 'react';
import React from 'react';

import Flag from '@atlaskit/flag/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';

type HeaderPresentationModeProps = {
	title: string;
};

export const ErrorFlag: FC<HeaderPresentationModeProps> = ({ title }) => {
	return (
		<Flag
			appearance="error"
			icon={<StatusErrorIcon spacing="spacious" label="Error" />}
			id="error"
			key="error"
			title={title}
		/>
	);
};
